import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const cookies: Recipe = {
  slug: 'cookies',
  title: 'Cookies aux trois chocolats',
  category: 'sucré',
  description: 'Pour environ 14 cookies, croustillants à l’extérieur et moelleux à l’intérieur.',
  image: image('cookies'),
  tags: ['chocolat', 'goûter', 'four'],
  meta: [
    { label: 'Pour', value: 'environ 14 cookies' },
    { label: 'Préparation', value: '15 à 20 min' },
    { label: 'Cuisson', value: 'environ 12 min par fournée' },
  ],
  sections: [
    section('Ingrédients', [
      ingredient('beurre', 'beurre fondu', '125 g de beurre fondu', {
        amount: 125,
        unit: 'g',
        shoppingKey: 'beurre',
      }),
      ingredient('œuf', 'œuf', '1 œuf', { amount: 1, unit: 'œuf', shoppingKey: 'œuf' }),
      ingredient('sucre', 'sucre', '150 g de sucre', { amount: 150, unit: 'g', shoppingKey: 'sucre' }),
      ingredient('farine', 'farine', '225 g de farine', { amount: 225, unit: 'g', shoppingKey: 'farine' }),
      ingredient('levure', 'levure chimique', '1/2 sachet de levure chimique'),
      ingredient('chocolat', 'chocolat', '150 g de chocolat en morceaux (ou pépites)', {
        amount: 150,
        unit: 'g',
        shoppingKey: 'chocolat',
      }),
      ingredient('fruits-secs', 'amandes ou noisettes', 'Quelques amandes ou noisettes concassées', {
        optional: true,
      }),
      ingredient('sucre-vanille', 'sucre vanillé', '1 sachet de sucre vanillé', { optional: true }),
    ]),
  ],
  steps: [
    'Préchauffer le four à 180 °C et faire fondre le beurre.',
    'Dans un saladier, mélanger la farine, la levure et le sucre (et le sucre vanillé si utilisé).',
    'Ajouter le beurre fondu et l’œuf, puis mélanger jusqu’à obtention d’une pâte homogène.',
    'Incorporer les morceaux de chocolat et les fruits secs concassés. On pourra mettre les morceaux de chocolat au congélateur au préalable pour mieux les incorporer.',
    'Former des petites boules sur une plaque recouverte de papier cuisson et enfourner à mi-hauteur pendant environ 12 minutes.',
  ],
  warning: 'Ne pas utiliser de feuille de cuisson silicone pour la cuisson.',
  note: 'Même si les cookies paraissent mous à la sortie du four, c’est normal : ils raffermissent en refroidissant.',
}
